module.exports = __webpack_public_path__ + "static/35-f88301c46914d9938c843e03595466eb.jpg";